import type { WidgetDefinition } from '../WidgetDefinition';
import { faTable } from '@fortawesome/pro-regular-svg-icons/faTable';
import type { StrategyWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import type { StrategyWidgetViewModel } from 'src/store/types';

class ResultsWidgetDefinition implements WidgetDefinition<StrategyWidgetViewModel, StrategyWidgetModel> {
    type = 'results' as const;
    nameKey = 'widgets::results::name' as const;
    roles = ['widgets::results'];
    icon = faTable;
    category = 'widgets::categories::research' as const;

    /**
     * Converts a Strategy/Results widget from contract model to view model
     */
    toViewModel(widget: StrategyWidgetModel): StrategyWidgetViewModel {
        const { ideas, ...restWidget } = widget;
        return { ...restWidget, ideas: ideas ?? [], columnOptions: restWidget.columnOptions };
    }

    /**
     * Converts a Strategy/Results widget from view model to contract model
     */
    toContractModel(widget: StrategyWidgetViewModel): StrategyWidgetModel {
        return widget;
    }
}

export const resultsWidgetDefinition = new ResultsWidgetDefinition();
